/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetVolunteersQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetVolunteersQuery = {
  volunteer: Array<
    Pick<
      Types.Volunteer,
      "primary_category_name" | "min_primary_signups" | "volunteer_hours"
    > & {
      event_attendee: Pick<Types.EventAttendee, "id"> & {
        user: Pick<Types.User, "name" | "email">;
        shift_signup?: Types.Maybe<
          Array<
            Pick<Types.ShiftSignup, "checked_in"> & {
              shift: Pick<
                Types.EventActivity,
                "id" | "name" | "start_time" | "end_time" | "category"
              >;
            }
          >
        >;
      };
    }
  >;
};

export const GetVolunteersDocument = gql`
  query GetVolunteers {
    volunteer(where: {}) {
      primary_category_name
      min_primary_signups
      volunteer_hours
      event_attendee {
        id
        user {
          name
          email
        }
        shift_signup {
          checked_in
          shift {
            id
            name
            start_time
            end_time
            category
          }
        }
      }
    }
  }
`;

/**
 * __useGetVolunteersQuery__
 *
 * To run a query within a React component, call `useGetVolunteersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolunteersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolunteersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVolunteersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetVolunteersQuery,
    GetVolunteersQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetVolunteersQuery,
    GetVolunteersQueryVariables
  >(GetVolunteersDocument, baseOptions);
}
export function useGetVolunteersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetVolunteersQuery,
    GetVolunteersQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetVolunteersQuery,
    GetVolunteersQueryVariables
  >(GetVolunteersDocument, baseOptions);
}
export type GetVolunteersQueryHookResult = ReturnType<
  typeof useGetVolunteersQuery
>;
export type GetVolunteersLazyQueryHookResult = ReturnType<
  typeof useGetVolunteersLazyQuery
>;
export type GetVolunteersQueryResult = ApolloReactCommon.QueryResult<
  GetVolunteersQuery,
  GetVolunteersQueryVariables
>;
